import {
	AchievementProgressState,
	type AchievementResponse,
	type ActivatedAchievementResponse
} from '../../domain/Achievement';
import { achievementResponseStore, findAllAchievementResponse } from '../../store/AchievementStore';
import { logger } from '../../logger';

export const activateAchievement = async (achievementId: string): Promise<ActivationResponse> => {
	let state = AchievementProgressState.CREATED;
	try {
		const response = await fetch(`/up-homeui/gateway/achievement/activate?achievementId=${achievementId}`, {
			method: 'POST'
		});
		if (response.status != 200) {
			await fetch(`/up-homeui/gateway/achievement/activate/metrics`, { method: 'POST' });
			return { state, loading: false };
		}
		const activatedAchievementResponse: ActivatedAchievementResponse = await response.json();
		if (activatedAchievementResponse.success) {
			updateAchievementResponseStore(achievementId);

			state = AchievementProgressState.ACTIVATED;
		}
		return { state, loading: false };
	} catch (error) {
		logger.error(error);
		return { state, loading: false };
	}
};

export type ActivationResponse = {
	state: AchievementProgressState;
	loading: boolean;
};

const updateAchievementResponseStore = (achievementId: string) => {
	const achievements = findAllAchievementResponse();
	const updatedActualAchievements = achievements?.actualAchievements.map(achievement => {
		if (achievement.achievementId === achievementId) {
			return {
				...achievement,
				progress: { ...achievement.progress, state: AchievementProgressState.ACTIVATED }
			};
		}
		return achievement;
	});
	const achievementResponse = {
		actualAchievements: updatedActualAchievements,
		pastAchievements: achievements?.pastAchievements,
		batchId: achievements ? achievements.batchId : 0
	} as AchievementResponse;
	achievementResponseStore.set(achievementResponse);
}
